import { CircularProgress, Grid, InputAdornment, styled, TextField } from '@material-ui/core'
import FilterNoneIcon from '@material-ui/icons/FilterNone'
import { Elements } from '@tfo/common'
import React from 'react'

const CopyIcon = styled(FilterNoneIcon)({
  transform: 'scale(0.8)',
})

const SelfServiceUrlButton = styled(Elements.Button)({
  display: 'flex',
  alignItems: 'center',
  color: '#0098C3',
  '&:hover': {
    color: '#007A9C',
  },
  '&:active': {
    transform: 'translateY(1px)',
  },
})

export const CopyableInputField: React.FC<{
  value: string
  sensitive?: boolean
  isLoading?: boolean
  copyValue: () => void
  copyValueLabel?: string
}> = ({ value, sensitive = false, isLoading, copyValue = () => {}, copyValueLabel }) => {
  
  return (<TextField
          autoComplete='off'
          fullWidth
          size='small'
          variant='outlined'
          type={sensitive ? 'password' : 'text'}
          value={value}
          InputProps={{
            readOnly: true,
            endAdornment: <InputAdornment position='end'>
              {!isLoading &&
                <SelfServiceUrlButton onClick={copyValue} disabled={!value}>
                  <CopyIcon />{copyValueLabel }
                </SelfServiceUrlButton>}
              {isLoading && <CircularProgress size={'2.5rem'} />}
            </InputAdornment>,
          }}
        />)
}